import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import dayjs from 'dayjs';
import jwt_decode, { JwtPayload } from 'jwt-decode';

export const baseUrl = process.env.REACT_APP_API_ENDPOINT;

export const instance = axios.create({
  baseURL: baseUrl
});

instance.interceptors.request.use<AxiosRequestConfig>(async req => {
  const authTokens = localStorage.getItem('authTokens')
    ? JSON.parse(localStorage.getItem('authTokens'))
    : null;

  if (authTokens) {
    const user = jwt_decode<JwtPayload>(authTokens.access_token);
    const isExpired = dayjs.unix(user.exp).diff(dayjs()) < 1;

    req.headers.Authorization = `Bearer ${authTokens.access_token}`;
    if (!isExpired) return req;

    const response = await axios.post(`${baseUrl}/auth/refresh`, {
      refresh_token: authTokens.refresh_token
    });

    localStorage.setItem('authTokens', JSON.stringify(response.data.data));
    req.headers.Authorization = `Bearer ${response.data.data.access_token}`;
  }

  return req;
});

instance.interceptors.response.use<AxiosResponse>(
  res => res,
  error => {
    const errorStatus = error.response?.status;

    if (
      (errorStatus === 401 && window.location.pathname !== '/') ||
      (errorStatus === 403 && window.location.pathname !== '/')
    ) {
      window.location.replace('/');
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);
